import { useTranslation } from "react-i18next";
import EmptyStateCardBase from "../Common/EmptyStateCard";

const EmptyStateCard = ({ onUpload }) => {
    const { t } = useTranslation();
    return (
        <EmptyStateCardBase
            title={t("CONTENT_EMPTY_TITLE")}
            description={t("CONTENT_EMPTY_DESCRIPTION")}
            actionLabel={t("CONTENT_EMPTY_ACTION")}
            onAction={onUpload}
            className="mt-10 px-6 py-20 text-center sm:px-8"
            icon={<span className="text-2xl">+</span>}
        />
    );
};

export default EmptyStateCard;
